// extracted by mini-css-extract-plugin
export default {"container":"styles_container__D2ktY","dark":"styles_dark__RFxFh","eye":"styles_eye__gUiit","opened":"styles_opened__+7uAP","closed":"styles_closed__+j9HV"};